/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_budget_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Predict which F1 Fantasy drivers and constructors are set for a price rise after this weekend. Built on the official price-change algorithm — so you can lock in rising picks before the deadline and stretch your budget further.`)
};

const es_f1_budget_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Predice qué pilotos y constructores de F1 Fantasy están listos para subir de precio después de este fin de semana. Basado en el algoritmo oficial de cambio de precios — para que puedas asegurar picks en alza antes de la fecha límite y estirar tu presupuesto al máximo.`)
};

const de_f1_budget_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prognostiziere, welche F1-Fantasy-Fahrer und -Konstrukteure nach diesem Wochenende im Preis steigen werden. Basierend auf dem offiziellen Preisänderungs-Algorithmus — damit du steigende Picks vor dem Deadline sichern und dein Budget optimal nutzen kannst.`)
};

const nl_f1_budget_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voorspel welke F1 Fantasy-coureurs en -constructeurs na dit weekend in prijs gaan stijgen. Gebaseerd op het officiële prijswijzigingsalgoritme — zodat je stijgende picks kunt vastzetten vóór de deadline en je budget optimaal benut.`)
};

const fr_f1_budget_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prédisez quels pilotes et constructeurs F1 Fantasy vont augmenter de prix après ce week-end. Basé sur l’algorithme officiel de changement de prix — pour verrouiller les picks en hausse avant la date limite et optimiser votre budget.`)
};

const it_f1_budget_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prevedi quali piloti e costruttori di F1 Fantasy sono destinati a un aumento di prezzo dopo questo weekend. Basato sull'algoritmo ufficiale di variazione dei prezzi — così puoi bloccare le scelte in rialzo prima della scadenza e sfruttare al meglio il tuo budget.`)
};

const pt_br2_f1_budget_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preveja quais pilotos e construtores do F1 Fantasy vão subir de preço após este fim de semana. Baseado no algoritmo oficial de mudança de preço — para você garantir escolhas em alta antes do prazo e esticar seu orçamento ao máximo.`)
};

const pt_f1_budget_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preveja quais pilotos e construtores de F1 Fantasy vão subir de preço após este fim de semana. Baseado no algoritmo oficial de alteração de preços — para poder garantir escolhas em alta antes do prazo e otimizar o seu orçamento.`)
};

const ja_f1_budget_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今週末後にどのF1ファンタジードライバーとコンストラクターが値上がりするかを予測。公式価格変更アルゴリズムに基づいて — デッドライン前に値上がりするピックを確保し、予算を最大限に活用しましょう。`)
};

const zh_f1_budget_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预测哪些F1梦幻车手和车队将在本周末后涨价。基于官方价格变动算法 — 在截止日期前锁定上涨选择，最大化利用你的预算。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_budget_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_budget_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_budget_intro", locale)
	if (locale === "en") return en_f1_budget_intro(inputs)
	if (locale === "es") return es_f1_budget_intro(inputs)
	if (locale === "de") return de_f1_budget_intro(inputs)
	if (locale === "nl") return nl_f1_budget_intro(inputs)
	if (locale === "fr") return fr_f1_budget_intro(inputs)
	if (locale === "it") return it_f1_budget_intro(inputs)
	if (locale === "pt-BR") return pt_br2_f1_budget_intro(inputs)
	if (locale === "pt") return pt_f1_budget_intro(inputs)
	if (locale === "ja") return ja_f1_budget_intro(inputs)
	return zh_f1_budget_intro(inputs)
};